import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';
import { dayActions, daysActions } from './hours.actions';
import { HoursDto, hoursInit } from './hours.dtos';

const hoursReducer = combineReducers({
    list: createReducer<HoursDto[]>([] as HoursDto[])
      .handleAction(
        [
          daysActions.success,
        ], (state, action) => action.payload),
  
    day: createReducer<HoursDto>(hoursInit)
      .handleAction(
        [
          dayActions.success,
        ], (state, action) => action.payload),
  
  });
  
  
  export default hoursReducer;